import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { AdminDashboardModel } from "src/app/model/AdminDashboardModel";
import { CheckerDashboardModel } from "src/app/model/CheckerDashboardModel";
import { InternalModeratorDashboardModel } from "src/app/model/InternalModeratorDashboardModel";
import { MakerDashboardModel } from "src/app/model/MakerDashboardModel";
import { ModerationInchargeDashboardModel } from "src/app/model/ModerationInchargeModel";
import { NodalOfficerDashboardModel } from "src/app/model/NodalOfficerDashboardModel";
import { HomeService } from "src/app/services/home.service";
import { AssignModerationModalComponent } from "./assign-moderation-modal/assign-moderation-modal.component";
import { ExeutiveEngieerHomeDashboardModel } from "src/app/model/ExeutiveEngieerHomeDashboardModel";
import { MasterService } from "src/app/services/master.service";
import { ExcelExportService } from "src/app/services/excel-export.service";

@Component({
  selector: "app-secure-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  userName: string;
  makerDashboardModel: MakerDashboardModel;
  checkerDashboardModel: CheckerDashboardModel;
  adminDashboardModel: AdminDashboardModel;
  internalModeratorDashboardModel: InternalModeratorDashboardModel;
  moderationInchargeDashboardModel: ModerationInchargeDashboardModel;
  nodalOfficerDashboardModel: NodalOfficerDashboardModel;
  exeutiveEngieerHomeDashboardModel: ExeutiveEngieerHomeDashboardModel;
  dataSource: any;
  loaded: boolean = false;
  date: Date;
  nocPendingCount: number;
  pageSize: any = 1;
  currentPage: any = 0;
  showTable: boolean = false;
  isLoadingReport: boolean = false;
  isLoading = false;
  displayedColumns: string[] = [
    "id",
    "applicationNumber",
    "applicantName",
    "schemaCode",
    "applicationDrawStatus",
  ];
  constructor(
    private router: Router,
    private homeService: HomeService,
    private modalCtrl: ModalController,
    private masterService: MasterService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    console.log(roles, "from rolls");

    this.homeService.fetchnOCPendingCount().subscribe(
      (data: any) => {
        console.log(data, " Hello Method Called");
        this.nocPendingCount = data.pendingNocCount;
        console.log(this.nocPendingCount, " Noc Count Method Called");
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
    console.log("rolesrolesrolesroles", roles);

    if (roles?.indexOf("ADMIN") >= 0) {
      console.log(" ADMINADMINADMINADMIN", roles?.indexOf("ADMIN"));
      this.homeService.fetchNodalOfficerDashboard().subscribe((dashboard) => {
        this.nodalOfficerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    } else if (roles?.indexOf("EXECUTIVE_ENGINEEER") >= 0) {
      console.log(
        " EXECUTIVE_ENGINEEEREXECUTIVE_ENGINEEER",
        roles?.indexOf("EXECUTIVE_ENGINEEER")
      );
      this.homeService
        .fetchExeutiveEngieerDashboard()
        .subscribe((dashboard) => {
          this.exeutiveEngieerHomeDashboardModel = dashboard;
          this.dataSource = this.exeutiveEngieerHomeDashboardModel.pendingList;
          this.loaded = true;
          this.date = new Date();
        });
    } else if (roles?.indexOf("SPOC") >= 0) {
      this.homeService.fetchNodalOfficerDashboard().subscribe((dashboard) => {
        this.nodalOfficerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    } else if (roles?.indexOf("MODERATION_MAKER") >= 0) {
      this.homeService.fetchMakerDashboard().subscribe((dashboard) => {
        this.makerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    } else if (roles?.indexOf("MODERATION_CHECKER") >= 0) {
      this.homeService.fetchCheckerDashboard().subscribe((dashboard) => {
        this.checkerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    } else if (
      roles?.indexOf("INTERNAL_MODERATOR") >= 0 ||
      roles?.indexOf("SPECIAL_INTERNAL_MODERATOR") >= 0
    ) {
      this.homeService
        .fetchModerationInchargeDashboard()
        .subscribe((dashboard) => {
          this.moderationInchargeDashboardModel = dashboard;
          this.loaded = true;
          this.date = new Date();
        });
    } else if (
      roles?.indexOf("NODAL_OFFICER") >= 0 ||
      roles?.indexOf("MANAGER") >= 0
    ) {
      this.homeService.fetchNodalOfficerDashboard().subscribe((dashboard) => {
        this.nodalOfficerDashboardModel = dashboard;
        this.loaded = true;
        this.date = new Date();
      });
    }
    // else if(roles?.indexOf('MODERATION_INCHARGE') >= 0) {
    //   this.homeService.fetchModerationInchargeDashboard().subscribe(dashboard => {
    //     this.moderationInchargeDashboardModel = dashboard;
    //   });
    // }
  }
  fetchMIS() {
    this.isLoadingReport = true;
    this.masterService
      .fetchReport
      // this.filterForm.value.filterText,
      // this.filterForm.value.nocFilter,
      // this.filterForm.value.schemeFilter,
      // this.filterForm.value.accepenceStatusFilter,
      // this.filterForm.value.polFilter,
      // this.filterForm.value.allotmentFilter,
      // this.filterForm.value.insPaymentFilter,
      // this.filterForm.value.appDrawStatus,
      // this.filterForm.value.incomeFilter,
      // this.filterForm.value.categoryFilter,
      // this.filterForm.value.possessionFilter,
      // this.filterForm.value.draftAllotmentFilter,
      // this.filterForm.value.firstInstStatus
      ()
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isLoadingReport = false;
          if (data.status === "SUCCESS") {
            this.excelExportService.exportExcel(
              data.title,
              data.columnNames,
              data.lst,
              data.columnWidths,
              data.generatedBy,
              data.generatedOn
            );
          } else {
            this.masterService.errorToast(data.errorMessage);
            this.isLoadingReport = false;
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isLoadingReport = false;
        }
      );
  }
  onClickPendingModeration() {
    this.router.navigate(["/secure", "moderation-list"]);
  }

  async assignModerationCases() {
    const modal = await this.modalCtrl.create({
      component: AssignModerationModalComponent,
      cssClass: "master-modal",
      componentProps: {
        obj: null,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      this.homeService.assignModerationCases(data).subscribe((res) => {
        if (res.status === "SUCCESS") {
          this.ngOnInit();
        } else {
          this.homeService.errorToast(res.errorMessage);
        }
      });
    }
  }

  refresh() {
    this.ngOnInit();
  }

  release(userId: string) {
    this.homeService.releaseModerationCases(userId).subscribe((res) => {
      if (res.status === "SUCCESS") {
        this.ngOnInit();
      } else {
        this.homeService.errorToast(res.errorMessage);
      }
    });
  }
}
